import { Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from 'lib/utils';

type SharedBadgeProps = {
  className?: string;
  showIcon?: boolean;
};

/** Compact chip: agent is shared with people / shared with you. */
export function SharedBadge({ className, showIcon = true }: SharedBadgeProps) {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-[#ccfbf1] bg-[#f0fdfa] px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-[#0f766e]',
        'dark:border-teal-900/40 dark:bg-teal-950/40 dark:text-teal-300',
        className
      )}
    >
      {showIcon ? <Users className="size-3 shrink-0" aria-hidden /> : null}
      {t('SHARED') || 'Shared'}
    </span>
  );
}

export type { SharedBadgeProps };
